import React, { LegacyRef, PureComponent } from 'react';
import { InputProps } from 'antd/lib/input';
import { Input } from 'antd';
import { HasFormValue } from 'app/common/input/HasFormValue';
import { TimePeriod } from 'app/model/CORE';
import Utils from 'app/common/util/Utils';
import TimeUtils from 'app/common/util/TimeUtils';
import InputTime from 'app/common/input/InputTime';

interface InputTimePeriodProps
    extends HasFormValue<TimePeriod>,
        Omit<InputProps, 'value' | 'defaultValue' | 'onChange'> {
    referenceDay: Date;
    autoFocus?: boolean;
    placeHolder?: string;
}

interface InputTimePeriodState {
    value: TimePeriod;
}

export default class InputTimePeriod extends PureComponent<InputTimePeriodProps, InputTimePeriodState> {
    constructor(props: InputTimePeriodProps) {
        super(props);
        this.state = {
            value: props.value,
        };
    }

    componentDidUpdate(prevProps, prevState): void {
        // If props.value changes, state must be updated accordingly
        if (prevProps.value !== this.props.value) {
            if (Utils.isNotEquals(this.props.value, this.state.value)) {
                this.setState({ value: this.props.value });
            }
        }
    }

    onFromChange = value => {
        let updatedValue = { ...this.state.value };
        if (!updatedValue) {
            updatedValue = {};
        }
        if (value) {
            updatedValue.from = TimeUtils.mergeDateAndTime(this.props.referenceDay, value);
        } else {
            updatedValue.from = null;
        }
        this.setState({ value: updatedValue });
        this.triggerChange(updatedValue);
    };
    onToChange = (value: Date) => {
        let updatedValue = { ...this.state.value };
        if (!updatedValue) {
            updatedValue = {};
        }
        if (value) {
            updatedValue.to = TimeUtils.mergeDateAndTime(this.props.referenceDay, value);
        } else {
            updatedValue.to = null;
        }
        this.setState({ value: updatedValue });
        this.triggerChange(updatedValue);
    };

    triggerChange(value: TimePeriod) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    ref: LegacyRef<HTMLInputElement> = React.createRef();
    render() {
        return (
            <Input.Group>
                <InputTime
                    autoFocus={this.props.autoFocus}
                    value={this.state.value && this.state.value.from}
                    style={{ width: '5em' }}
                    placeholder={this.props.placeHolder ?? ''}
                    onChange={this.onFromChange}
                />
                <InputTime
                    value={this.state.value && this.state.value.to}
                    style={{ width: '5em' }}
                    placeholder={this.props.placeHolder ?? ''}
                    onChange={this.onToChange}
                />
            </Input.Group>
        );
    }
}
